// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPoweroffOutlinedSvg from "@fishx/icons-svg/es/asn/PPoweroffOutlined";
import FishxIcon from '../components/FishxIcon';

var PPoweroffOutlined = function PPoweroffOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPoweroffOutlinedSvg
  }));
};

PPoweroffOutlined.displayName = 'PPoweroffOutlined';
export default React.forwardRef(PPoweroffOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPoweroffOutlined.js
// module id = 3549
// module chunks = 0